import { z } from "zod";
import {
  isValidPhoneNumber,
  parsePhoneNumberWithError,
} from "libphonenumber-js";
import { t } from "i18next";

export const AccountSettingSchema = (): z.ZodObject<{
  firstname: z.ZodString;
  lastname: z.ZodString;
  phone: z.ZodEffects<
    z.ZodEffects<z.ZodString, string, string>,
    string,
    string
  >;
  country: z.ZodString;
  state: z.ZodString;
  city: z.ZodString;
  occupation: z.ZodString;
  occupationId: z.ZodNumber;
}> =>
  z.object({
    firstname: z.string().min(2, t("schemas.accountSettings.firstname.min")),
    lastname: z.string().min(2, t("schemas.accountSettings.lastname.min")),
    phone: z
      .string()
      .refine(isValidPhoneNumber, {
        message: t("schemas.accountSettings.phone.format"),
      })
      .transform((value) => parsePhoneNumberWithError(value).number.toString()),
    country: z.string(),
    state: z.string(),
    city: z.string(),
    occupation: z.string(),
    occupationId: z.number(),
  });

export type AccountSettingSchemaType = z.infer<
  ReturnType<typeof AccountSettingSchema>
>;
export type AccountFormFieldKey = keyof AccountSettingSchemaType;
